import {executeOnCaptchaSuccess} from "./captcha-handler";

const init = () => {
	const errorMessages = document.querySelectorAll(".field-validation-error");

	errorMessages.forEach(error => {
		const controlId = error.attributes["data-valmsg-for"].value;
		const inputError = document.getElementById(controlId);

		if(inputError)
			inputError.classList.add("error");
	});

	const submitButton = document.getElementById("contact-form-submit");
	submitButton.addEventListener("click", (e) => {
		const form = e.target.closest("form");

		executeOnCaptchaSuccess(() => { form.submit(); });
	});
}

init();
